import { BookingDataContext } from "containers/data_context";
import moment from "moment";
import { useContext, useEffect, useState } from "react";

export default function useHandleNotifications() {
  const { notifications } = useContext(BookingDataContext);

  const { data: notificationsData = [] } = notifications;
  const [filteredNotifications, setFilteredNotifications] = useState([]);

  useEffect(() => {
    if (notificationsData) {
      const filterNotifications = () => {
        if (notificationsData?.length > 0) {
          const today = moment();
          const filteredNoti = notificationsData?.filter((notification) => {
            const notificationStartDate = moment(notification?.start_date);
            const notificationEndDate = moment(notification?.end_date);
            return today.isBetween(notificationStartDate, notificationEndDate, undefined, "[]");
          });

          setFilteredNotifications(filteredNoti);
        }
      };
      filterNotifications();
    }
  }, [notificationsData]);

  const isNotificationExists = (name) => {
    const notificationIndex = filteredNotifications?.find((noti) => noti?.name === name);
    return notificationIndex !== -1;
  };
  const hideNotification = (name) => {
    let notis = [...filteredNotifications];
    notis = notis?.filter((notification) => notification?.name !== name);
    setFilteredNotifications(notis);
  };
  return {
    notifications: filteredNotifications,
    isNotificationExists,
    hideNotification,
  };
}
